"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var AdvertModule = /** @class */ (function (_super) {
    __extends(AdvertModule, _super);
    function AdvertModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 分页查询文章列表
     * @param column 文章栏目(1 => 集团动态，2 => 媒体报道，3 => 培训资料,null => 当前终端全部)
     * @param page
     * @param pageSize
     * @param terminal 终端位置(1Xbed官网，2丽家会，3其他，null 全部终端)
     * @param token
     */
    AdvertModule.prototype.queryArticleList = function (params, token) {
        return this.gatewayClient.queryArticleList(params, token);
    };
    /**
     * 添加文章
     * @param SEOtags SEO标签(逗号分割)
     * @param column 文章栏目(1集团动态，2媒体报道)
     * @param content	文章内容
     * @param coverPicPath 封面图片地址
     * @param createName 创建人
     * @param reprintUrl 转载链接
     * @param source 文章来源(1原创，2转载)
     * @param status 状态(0隐藏，1显示)
     * @param summary 文章摘要
     * @param terminal 终端位置(1Xbed官网，2IOS,3安卓，4微信)
     * @param title 文章标题
     * @param sortNum 优先级
     * @param city 文章所配置的城市，其他栏目不传
     * @param cityId 城市Id,与城市名顺序保持一致
     * @param type 类型（1新闻动态 2旅游攻略 3丽家会培训 4 其他）
     * @param token
     */
    AdvertModule.prototype.addArticle = function (params, token) {
        return this.gatewayClient.addArticle(params, token);
    };
    /**
     * 文章列表页下拉列表
     * @param type 文章类型
     * @param token
     */
    AdvertModule.prototype.getArticleSelective = function (params, token) {
        return this.gatewayClient.getArticleSelective(params, token);
    };
    /**
     * 删除文章
     * @param articleId 文章id
     * @param updateName 操作人
     */
    AdvertModule.prototype.deleteArticle = function (articleId, updateName, token) {
        return this.gatewayClient.deleteArticle(articleId, updateName, token);
    };
    /**
     * 编辑文章
     * @param SEOtags SEO标签(逗号分割)
     * @param articleId 文章ID
     * @param column 文章栏目(1集团动态，2媒体报道)
     * @param content	文章内容
     * @param coverPicPath 封面图片地址
     * @param updateName 更新人
     * @param reprintUrl 转载链接
     * @param source 文章来源(1原创，2转载)
     * @param status 状态(0隐藏，1显示)
     * @param summary 文章摘要
     * @param terminal 终端位置(1Xbed官网，2IOS,3安卓，4微信)
     * @param title 文章标题
     * @param sortNum 优先级
     * @param type 类型（1新闻动态 2旅游攻略 3丽家会培训 4 其他）
     * @param city 文章所配置的城市，其他栏目不传
     * @param cityId 城市Id,与城市名顺序保持一致
     * @param token
     */
    AdvertModule.prototype.editArticle = function (params, token) {
        return this.gatewayClient.editArticle(params, token);
    };
    /**
     * 文章详情
     * @param articleId 文章id
     */
    AdvertModule.prototype.getArticleDetails = function (articleId) {
        return this.gatewayClient.articleDetails(articleId);
    };
    /**
     * 编辑文章置顶
     * @deprecated
     * @param articleId 文章ID
     * @param top 是否置顶
     * @param updateName 修改人
     * @param token
     */
    AdvertModule.prototype.topArticle = function (articleId, top, updateName, token) {
        return this.gatewayClient.topArticle(articleId, top, updateName, token);
    };
    /**
     * 分页查询广告列表
     * @param page
     * @param pageSize
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网，6丽家会)
     */
    AdvertModule.prototype.queryAdvertList = function (page, pageSize, type, name, terminal, token) {
        return this.gatewayClient.queryAdvertList(page, pageSize, type, name, terminal, token);
    };
    /**
     * 删除广告
     */
    AdvertModule.prototype.deleteAdvert = function (advertId, updateName, token) {
        return this.gatewayClient.deleteAdvert(advertId, updateName, token);
    };
    /**
     * 添加广告
     * @param createName 创建人
     * @param materialId 素材ID
     * @param name
     * @param picPath 图片地址
     * @param remark
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计
     * @param url 	外部链接地址
     * @param sortNum 排序值
     * @param token
     */
    AdvertModule.prototype.addAdvert = function (params, token) {
        return this.gatewayClient.addAdvert(params, token);
    };
    /**
     * 编辑广告
     * @param advertId 广告ID
     * @param materialId 素材ID
     * @param name
     * @param picPath 图片地址
     * @param remark
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端(0所有，1微信，2IOS，3Android，4微信蓝主人，5Xbed官网)
     * @param type 广告类型(1轮播图，2广告图，3招聘图，4热门城市图，5新闻动态，6精品设计
     * @param updateName
     * @param url 	外部链接地址
     * @param token
     */
    AdvertModule.prototype.editAdvert = function (params, token) {
        return this.gatewayClient.editAdvert(params, token);
    };
    /**
     * 查询销售中状态的房间List
     * @param key 房间ID/名
     * @param token
     */
    AdvertModule.prototype.queryHomeList = function (params, token) {
        return this.gatewayClient.queryHomeList(params, token);
    };
    /**
     * XBED渠道中上线门店List
     * @param key 门店id/名
     * @param token
     */
    AdvertModule.prototype.queryStoreList = function (params, token) {
        return this.gatewayClient.queryStoreList(params, token);
    };
    /**
     * 置顶广告
     * @param advertId 广告ID
     * @param top 是否置顶
     * @param updateName 修改人
     * @param token
     */
    AdvertModule.prototype.topAdvert = function (advertId, top, updateName, token) {
        return this.gatewayClient.topAdvert(advertId, top, updateName, token);
    };
    /**
     * 热门城市列表
     * @param page
     * @param pageSize
     */
    AdvertModule.prototype.queryHotCityList = function (page, pageSize, cityName, token) {
        return this.gatewayClient.queryHotCityList(page, pageSize, cityName, token);
    };
    /**
     * 查询不存在热门城市表的城市列表
     * @param token
     */
    AdvertModule.prototype.queryNotExistHotCity = function (token) {
        return this.gatewayClient.queryNotExistHotCity(token);
    };
    /**
     * 新增热门城市
     * @param cityName
     * @param cityPicUrl 城市图片URL
     * @param sortNum 排序值
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端位置(0所有，1微信，2IOS，3Android)
     * @param createName 创建人
     */
    AdvertModule.prototype.addHotCity = function (params, token) {
        return this.gatewayClient.addHotCity(params.cityName, params.cityPicUrl, params.sortNum, params.status, params.terminal, params.createName, token);
    };
    /**
     * 编辑热门城市
     * @param id
     * @param cityName
     * @param cityPicUrl 城市图片URL
     * @param sortNum 排序值
     * @param status 状态(0关闭，1开启)
     * @param terminal 终端位置(0所有，1微信，2IOS，3Android)
     * @param updateName 修改人
     */
    AdvertModule.prototype.editHotCity = function (params, token) {
        return this.gatewayClient.editHotCity(params.id, params.cityName, params.cityPicUrl, params.sortNum, params.status, params.terminal, params.updateName, token);
    };
    /**
     * 删除热门城市
     * @param id
     * @param updateName
     * @param token
     */
    AdvertModule.prototype.delHotCity = function (id, updateName, token) {
        return this.gatewayClient.delHotCity(id, updateName, token);
    };
    /**
     * 删除推荐房间
     * @param id
     * @param updateName 修改人
     * @param token
     */
    AdvertModule.prototype.deleteRecommendRoom = function (id, updateName, token) {
        return this.gatewayClient.deleteRecommendRoom(id, updateName, token);
    };
    /**
     * 推荐房间列表
     * @param page 页码
     * @param pageSize 每页大小
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param token
     */
    AdvertModule.prototype.recommendRoomList = function (params, token) {
        return this.gatewayClient.recommendRoomList(params.page, params.pageSize, params.type, token);
    };
    /**
     * 新增推荐房间
     * @param createName 创建人
     * @param roomId Xbed房间ID
     * @param roomName Xbed房间名称
     * @param roomNo Xbed房间编号
     * @param status 状态(0关闭，1开启)
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param token
     */
    AdvertModule.prototype.addRecommendRoom = function (params, token) {
        return this.gatewayClient.addRecommendRoom(params.createName, params.roomId, params.roomName, params.roomNo, params.status, params.type, token);
    };
    /**
     * 编辑推荐房间
     * @param id
     * @param roomId Xbed房间ID
     * @param roomName Xbed房间名称
     * @param roomNo Xbed房间编号
     * @param status 状态(0关闭，1开启)
     * @param type 类型(2精选,3小住,4长留,5发现)
     * @param updateName
     * @param token 修改人
     */
    AdvertModule.prototype.editRecommendRoom = function (params, token) {
        return this.gatewayClient.editRecommendRoom(params.id, params.roomId, params.roomName, params.roomNo, params.status, params.type, params.updateName, token);
    };
    /**
     * 查询还未推荐的房间列表
     * @param page
     * @param pageSize
     * @param type 类型(2精选,3小住,4长留,5发现)
     */
    AdvertModule.prototype.queryNotExistRecommendRooms = function (page, pageSize, type, chainName, roomName, roomNo, token) {
        return this.gatewayClient.queryNotExistRecommendRooms(page, pageSize, type, chainName, roomName, roomNo, token);
    };
    /**
     * 查询全部城市
     */
    AdvertModule.prototype.queryAllCities = function (token) {
        return this.gatewayClient.listAllCity(true, token);
    };
    /**
     * 视频列表
     * @param page
     * @param pageSize
     * @param token
     */
    AdvertModule.prototype.queryVideoList = function (params, token) {
        return this.gatewayClient.videoList(params, token);
    };
    /**
     * 视频添加/修改
     * @param videoId
     * @param displayTerminalId 显示终端： 1 pc预定端，2其它
     * @param framePictureUrl 视频某一帧图url
     * @param sort 排序
     * @param status 状态 1 开启 0 关闭
     * @param user 操作人
     * @param videoCoverUrl 视频封面url
     * @param videoLength 视频时长
     * @param videoTitle 视频标题
     * @param videoUrl 视频链接
     * @param token
     */
    AdvertModule.prototype.updateVideo = function (params, token) {
        return this.gatewayClient.updateVideo(params, token);
    };
    /**
     * 视频删除
     * @param user 操作人
     * @param videoId 视频id
     * @param token
     */
    AdvertModule.prototype.deleteVideo = function (params, token) {
        return this.gatewayClient.deleteVideo(params, token);
    };
    /**
     * 显示终端列表
     * @param type 类型： video(视频)
     * @param token
     */
    AdvertModule.prototype.queryVideoTerminal = function (type, token) {
        return this.gatewayClient.videoTerminal(type, token);
    };
    return AdvertModule;
}(gateway_module_1.GatewayModule));
exports.AdvertModule = AdvertModule;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/advert/index.js
// module id = 208
// module chunks = 44